// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__PScWX","title":"NotFound_title__1Oxqn","text":"NotFound_text__2P0O1"};